import { v4 as uuidv4 } from 'uuid';

import { isValidSessionId } from './isValidSessionId';

const QUERY_PARAM_NAME = 'zepQuizApplicationSessionId';

/**
 * 새로고침하기 전까지 유지되는 Application-level Session ID입니다.
 * 새로고침할 때마다 변경됩니다.
 */
function _getApplicationSessionId() {
  let sessionId: string | null = null;

  return function () {
    if (typeof window === 'undefined') {
      return null;
    }

    if (sessionId == null) {
      /** 퀴즈에서 iframe으로 코어 서비스를 띄우는 경우, QueryParam을 사용해서 sessionId를 일관되게 관리합니다. */
      const searchParams = new URLSearchParams(window.location.search);
      // URL 쿼리는 공개 입력이라 검증한다(getBrowserSessionId 와 동일 이유).
      const fromQuery = searchParams.get(QUERY_PARAM_NAME);
      sessionId = isValidSessionId(fromQuery) ? fromQuery : uuidv4();
    }
    return sessionId;
  };
}

export const getApplicationSessionId = _getApplicationSessionId();
